export default __webpack_public_path__ + "static/media/banner-title.24e8df85.png";